/*
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.modes = {
                normal: "normal",
                toggle: "toggle"
            };
        }
*/
import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyString } from "../../RadObject";
import { ClientAwareCategoryAttribute } from "../../Server/DotNet/SeriouslyRAD.Framework/ClientAwareCategoryAttribute";
import { ClientAwareDisplayNameAttribute } from "../../Server/DotNet/SeriouslyRAD.Framework/ClientAwareDisplayNameAttribute";
import { ElementRef } from "../ElementRef";
import { JsxFragment } from "../JsxFragment";
import { NAMESPACE } from "./_Namespace";
import { IToolbarItem, ToolbarItem, ToolbarItemPropertyValues } from "./ToolbarItem";

import "./ToolbarImage.scss";

export type ToolbarImagePropertyValues =
    ToolbarItemPropertyValues
    & {
        image: string;
    };

export type ToolbarImageProperties = {
    [name in keyof ToolbarImagePropertyValues]: Property<ToolbarImagePropertyValues[name]>
};

export interface IToolbarImage extends IToolbarItem, ToolbarImageProperties
{
}

export class ToolbarImage extends ToolbarItem implements IToolbarImage
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ToolbarImage";
    public static override className = "ToolbarImage";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ToolbarImagePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected _imageElementRef!: ElementRef;

    // #endregion

    // #region Properties

    public image!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ToolbarImagePropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-toolbar-image");

        // Trigger Property Changes
        this.image.triggerChange();
    }

    // #endregion

    // #region Protected Methods

    protected _imageChanged(change: PropertyChange<string>)
    {
        if (change.currentValue)
            this._imageElementRef.current.attr("src", change.currentValue).show();
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: ToolbarImagePropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this._imageElementRef = new ElementRef();

        this.image = new PropertyString({
            context: this,
            initialValue: propertyValues.image,
            changeHandler: this._imageChanged,
            attributes: [
                new ClientAwareCategoryAttribute({ category: "Appearance" }),
                new ClientAwareDisplayNameAttribute({ displayName: "Image" }),
            ],
        });
    }

    protected override _createElementComplete()
    {
        super._createElementComplete();

        this._imageElementRef.current.hide();
    }
    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[])
    {
        return (
            <a>
                <span ref={this._containerElementRef} class="rad-container">
                    <img ref={this._imageElementRef}></img>
                    {children}
                </span>
            </a>
        );
    }

    // #endregion

    // #endregion
}

